// extracted by mini-css-extract-plugin
export default {"btn":"RightArrow_btn__-UVmo","btnRight":"RightArrow_btnRight__kuioH"};